<template>  
    <section class="block block--textimage">
        <div
            v-if="block.image"
            class="text__img"
            :class="{ 'text__img--left' : block.img_position === 'left' }"
            :style="{ backgroundImage: `url('${$VUE_APP_API_URL + block.image.url}')` }"
            :alt="block.image.caption"
            @click="lightbox(block.image)">
            <div class="text__img--overlay"></div>
        </div>
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 text__content"
                    :class="block.img_position === 'left' ? 'order-md-2 text-left' : 'text-right'">
                    <h2 v-if="block.title">{{ block.title }}</h2>
                    <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
                    <div v-if="block.content" v-html="block.content"></div>
                </div>
                <div class="col-md-6" :class="{ 'order-md-1' : block.img_position === 'left' }">
                </div>
            </div>
        </div>
        <Lightbox v-if="clickedImage" :image.sync="clickedImage" />
    </section>
</template>

<script>
import Lightbox from '../Lightbox'

export default { 
    name: 'textimage',

    components: { Lightbox },

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            clickedImage: null
        }
    },

    methods: {
        lightbox(img) {
            this.clickedImage = img
        }
    }
}
</script>